export default (props) => (
  /**
   * Ícone que representa usuário padrão
   */
  <svg
    width="29"
    height="29"
    viewBox="0 0 29 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M20.6649 12.8866C20.6649 16.2934 17.9038 19.0535 14.4974 19.0535C11.0923 19.0535 8.33044 16.2931 8.33044 12.8866C8.33044 9.48127 11.0923 6.71967 14.4974 6.71967C17.9038 6.71995 20.6649 9.48156 20.6649 12.8866Z"
      fill="#CEDEFF"
    />
    <path
      d="M24.3854 24.5112C21.8533 21.9843 18.3579 20.4214 14.498 20.4214C10.6383 20.4214 7.1432 21.9843 4.61021 24.5112C7.1432 27.0372 10.6383 28.5995 14.498 28.5995C18.3579 28.5995 21.8533 27.0372 24.3854 24.5112Z"
      fill="#CEDEFF"
    />
    <path
      d="M14.4979 0.599243C6.76617 0.599243 0.497925 6.86807 0.497925 14.5995C0.497925 22.3322 6.76617 28.5995 14.4979 28.5995C22.2303 28.5995 28.4979 22.3322 28.4979 14.5995C28.4979 6.86807 22.2303 0.599243 14.4979 0.599243ZM14.4979 27.0301C7.63273 27.0301 2.06708 21.4653 2.06708 14.5995C2.06708 7.73462 7.63273 2.1684 14.4979 2.1684C21.3637 2.1684 26.9288 7.73462 26.9288 14.5995C26.9288 21.4653 21.3637 27.0301 14.4979 27.0301Z"
      fill="#CEDEFF"
    />
  </svg>
);
